export default "__VITE_ASSET__C$dKmrkC__"